import { Component } from '@angular/core';


@Component({
    selector: 'i360-tabs',
    template: `
        <div class="flexer flex-nowrap">
           <ng-content></ng-content>
        </div>
    `,
    styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent {}
